var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.initialised)?_c('div',[_c('activities',{attrs:{"current-user":_vm.crud.data,"readonly":true}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }